class Constants {
  static sectionTexts = {
    values:
      "仕事に求める価値観や、どのような働き方を重視しているかなどの嗜好性を判定するぞ！あまり考え込まず直感で回答するのじゃ！",
    personality:
      "次に自分がどんな性格のタイプなのか、自身では気づけなかった強みや弱みを判定するぞ！サクサク答えるのじゃ！",
  };

  static progressTexts = {
    early: "サクサク答えよう！",
    middle: "その調子！",
    late: "あともう少し！",
  };

  static progressWaitTexts = {
    early: "診断中…",
    middle: "診断中………",
    late: "診断中……………",
  };

  static formElements = [
    {
      label: "age",
      labelName: "年齢",
      type: "number",
      placeholder: "",
      required: true,
    },
    {
      label: "sex",
      labelName: "性別",
      type: "select",
      placeholder: "",
      required: true,
      options: ["男", "女", "答えない"],
    },
    {
      label: "area",
      labelName: "お住いの都道府県",
      type: "select",
      placeholder: "",
      required: true,
      options: [
        "-",
        "北海道",
        "青森県",
        "岩手県",
        "宮城県",
        "秋田県",
        "山形県",
        "福島県",
        "茨城県",
        "栃木県",
        "群馬県",
        "埼玉県",
        "千葉県",
        "東京都",
        "神奈川県",
        "新潟県",
        "富山県",
        "石川県",
        "福井県",
        "山梨県",
        "長野県",
        "岐阜県",
        "静岡県",
        "愛知県",
        "三重県",
        "滋賀県",
        "京都府",
        "大阪府",
        "兵庫県",
        "奈良県",
        "和歌山県",
        "鳥取県",
        "島根県",
        "岡山県",
        "広島県",
        "山口県",
        "徳島県",
        "香川県",
        "愛媛県",
        "高知県",
        "福岡県",
        "佐賀県",
        "長崎県",
        "熊本県",
        "大分県",
        "宮崎県",
        "鹿児島県",
        "沖縄県",
      ],
    },
    {
      label: "distance",
      labelName: "通勤にかかる時間の許容範囲",
      type: "select",
      placeholder: "",
      required: false,
      options: ["-", "10分圏内", "30分", "1時間", "2時間"],
    },
    {
      label: "importance",
      labelName: "仕事を探す上で重要視している点",
      type: "select",
      placeholder: "",
      required: false,
      options: ["-", "勤務地", "給料", "仕事内容", "休日"],
    },
  ];

  static categories = [
    {
      value: 0,
      label: "バランス",
    },
    {
      value: 1,
      label: "収入",
    },
    {
      value: 2,
      label: "安定",
    },
    {
      value: 3,
      label: "ライフスタイル",
    },
    {
      value: 4,
      label: "環境",
    },
    {
      value: 5,
      label: "診断外",
    },
  ];

  static sexs = [
    {
      value: 1,
      label: "男性",
    },
    {
      value: 2,
      label: "女性",
    },
    {
      value: 3,
      label: "答えない",
    },
  ];

  static questionsLen = {
    vQuestions: 5,
    pQuestions: 25,
  };

  static answersLen = {
    vQuestions: 4,
    pQuestions: 6,
  };

  static optionsLen = {
    vQuestions: 4,
    pQuestions: 2,
  };

  static valuesResults = [
    {
      id: 1,
      type: "高い目標！ガツガツパワフル",
      importance: "高い目標に取り組み、何事にもチャレンジング！",
      desc:
        "結果を出すまでは困難があっても逃げず、責任感をもって高い目標を目指します。\n" +
        "成果を重視し、仕事中心になりがちなタイプです。\n" +
        "過度な成果主義に走ってしまうこともあるため、注意が必要です。",
    },
    {
      id: 2,
      type: "効率重視！自分の時間が大切",
      importance: "難しく考えすぎず、シンプルに考えられる思考",
      desc:
        "必要でないことは切り捨て、効率よく物事を進められる事、優先順位、目標設定が得意です。\n" +
        "機能的、合理的といった言葉を好みます。\n" +
        "計画を重視するあまり、失敗すると崩れやすいという特徴があります。",
    },
    {
      id: 3,
      type: "the 職人肌！将来安心安泰",
      importance: "数々の試練を乗り越えた経験と実力",
      desc:
        "どんなに難しいことでも粘り強く物事を成し遂げようと努力する特徴があります。\n" +
        "正確性、質を重視、根気強いというのがこのタイプのキーワードです。\n" +
        "厳しい基準（完璧）を他人へ求める傾向があります。",
    },
    {
      id: 4,
      type: "いつでも人気者！ムードメーカー",
      importance: "自分の考えを率直に合わせられるコミュニケーション力",
      desc:
        "社交的で誰に対しても積極的に関わり、新しい発見を引き出す能力を持っています。\n" +
        "楽観的・創造的といった特徴を持ち合わせています。\n" +
        "一方で深く考えずに行動しやすいといった一面も。",
    },
  ];

  static personalityResults = [
    {
      id: 1,
      arr: [0, 1],
      type: "愛想を振りまく海賊王",
      desc:
        "豪快に見えて人間関係に非常に気を遣うあなた。\n" +
        "自分がでしゃばり過ぎないように、周りをよく見ながら行動をコントロールする性格です。\n" +
        "その反面、悪意や悪気はないが、陰で悪口を叩く側に回ってしまっている事がありますので注意が必要です。",
    },
    {
      id: 2,
      arr: [0, 2],
      type: "エネルギッシュなインストラクター",
      desc:
        "性格的に一本気でかなりアクが強いあなた。\n" +
        "本人は良かれと思ってやったことが、他人にはイヤな事であったりして…。\n" +
        "陰で悪口を言われてしまう結果になる可能性があります。",
    },
    {
      id: 3,
      arr: [0, 3],
      type: "派手好きなイベントプロデューサー",
      desc:
        "元気で前向きなあなた。\n" +
        "楽しみを求め計画します。みんなでワイワイ楽しむのが好き人生は\n" +
        "楽しく生きたい楽天家のような性格です。",
    },
    {
      id: 4,
      arr: [0, 4],
      type: "インドアな探検家",
      desc:
        "一つのことに取り組み始めたら、よそ見をせずに続けられるあなた。\n" +
        "一度っきりの人生、いろんなことを経験したいと思う性格です。\n" +
        "孤独であることに居心地の良さを感じていたり、\n" +
        "1人の時間を大切にしたいという価値観が強い特徴があります。",
    },
    {
      id: 5,
      arr: [0, 5],
      type: "単独公演希望のイルカ",
      desc:
        "知的好奇心が強く自身の知識を深めることを求めているあなた。\n" +
        "一人で悩みを抱える傾向があり、時に現実逃避してしまい、衝動的になってしまうことも。\n" +
        "怒りっぽくなる面もありますので注意です。",
    },
    {
      id: 6,
      arr: [1, 2],
      type: "直立不動のろうそく",
      desc:
        " 自分のことそっちのけで他人を優先するあなた。\n" +
        "自分の主張より他人の主張や調和を保つことを重視する性格です。\n" +
        "内面に無意識的に蓋をしているので、湧き上がるものが少なくモチベーションが低い特徴があります。",
    },
    {
      id: 7,
      arr: [1, 3],
      type: "幸せをちょっとずつ振りまく観音菩薩",
      desc:
        "とにかくいろんな事に興味を持つ創造性豊富なあなた。\n" +
        "自分の創造性を刺激して斬新なアイディアを生み出す性格です。\n" +
        "気分屋な面があります。親切な行動をとることもあれば、気分が乗らないときは突っぱねる傾向が見られます。",
    },
    {
      id: 8,
      arr: [1, 4],
      type: "恥ずかしがりやなほっこりポエマー",
      desc:
        "人の話を聞いたりするのが得意なあなた。\n" +
        "観察力が高く、一見バラバラと思えることをすんなり結び合わせられます。\n" +
        "アドリブは苦手で、極度の緊張で手が汗ばみ、まったく頭が回らないなどの特徴があります。",
    },
    {
      id: 9,
      arr: [1, 5],
      type: "自由奔放な幼稚園の先生",
      desc:
        "周囲にあまり関心が無く自分の興味のあることだけに集中するあなた。\n" +
        "周囲のウワサ話や陰口には全く興味が無い性格です。\n" +
        "本人はただ飄々と生きているだけなのに、周囲の人たちはどこか諭されたような気分してしまう可能性があります。",
    },
    {
      id: 10,
      arr: [2, 3],
      type: "経験豊富なベテラン軍師",
      desc:
        "成功を追い求めるあなた。価値のある人間になりたいと強く願う傾向が見られます。目標は達成しなければ意味がないと考える性格です。\n" +
        "考え方がちょっと自己中心的なので、自分勝手な人という印象を与えてしまう場合も多い傾向が見られます。",
    },
    {
      id: 11,
      arr: [2, 4],
      type: "人見知りがちなスナイパー",
      desc:
        "広い視野で知識を得て観察するあなた。物事を徹底的に調べる、心の隙間を知識で埋め込みたい性格です。\n" +
        "確信するまで動かず、始動が遅れやすい、慎重になりすぎて一向に前に進めない一面があります。",
    },
    {
      id: 12,
      arr: [2, 5],
      type: "直球勝負の勝負師キャッチャー",
      desc:
        "すべてにおいて完全でありたいあなた。\n" +
        "目標を達成するためには努力を惜しまない、間違えるのはとよくないと常に慎重になる性格のようです。\n" +
        "ただし、自分にも他人にも完璧さを求める気持ちが行き過ぎないように注意する必要があります。\n" +
        "他人にも完璧を求めすぎると人間関係がギクシャクしてしまいます。",
    },
    {
      id: 13,
      arr: [3, 4],
      type: "ネット掲示板で活動を行う革命家",
      desc:
        " 常に人の役に立てていることに実感を感じたいあなた。人の良い部分を引き出すのが得意な性格です。",
    },
    {
      id: 14,
      arr: [3, 5],
      type: "100年先をいくファッションリーダー",
      desc:
        "複数の分野を結びつけ、世にない物を生み出す力を持つあなた。\n" +
        "興味があるものには手当たり次第に吸収し、何をするにも覚えが早い性格です。\n" +
        "手当たり次第に手をつけるため、周りから中途半端だと非難を受ける可能性があります。",
    },
    {
      id: 15,
      arr: [4, 5],
      type: "武の道を極める武闘家",
      desc:
        "理論的思考で現実主義のあなた。どんな事も深く読み解き、最後までしっかりとやり遂げる能力を持つ性格です。\n" +
        "個性が強く、周りの人と打ち解けるまで、普通の人の数倍の時間がかかります。そのため交友関係は狭い特徴があります。",
    },
  ];

  static FLIP_STYLE = {
    // 前面⇒背面
    entering: {
      transition: "all .5s ease",
      transform: "perspective(25rem) rotateY(360deg)",
    },
    // 背面
    entered: {
      transition: "",
      transform: "perspective(25rem) rotateY(0deg)",
    },
    // 背面⇒前面
    exiting: {
      transition: "all .5s ease",
      transform: "perspective(25rem) rotateY(360deg)",
    },
    // 前面
    exited: {
      transition: "",
      transform: "perspective(25rem) rotateY(0)",
    },
  };

  static FLIP_BACK_STYLE = {
    // 前面⇒背面
    entering: {
      transition: "all .5s ease",
      transform: "perspective(25rem) rotateY(-360deg)",
    },
    // 背面
    entered: {
      transition: "",
      transform: "perspective(25rem) rotateY(0deg)",
    },
    // 背面⇒前面
    exiting: {
      transition: "all .5s ease",
      transform: "perspective(25rem) rotateY(-360deg)",
    },
    // 前面
    exited: {
      transition: "",
      transform: "perspective(25rem) rotateY(0)",
    },
  };
}

export default Constants;
